import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  BedingungsvergleichButton,
  Headline,
  actions,
  appActions,
  useGotoPage,
  useNextPage,
  Vorgangsanlage,
  VorgangsanlageButton, istEnumAuswahl,
} from 'ion-lib';
import { useDispatch, useSelector } from 'react-redux';
import i18n from 'i18next';
import Hausrat from '../../assets/img/Hausrat.svg';
import Glas from '../../assets/img/Glasversicherung.svg';
import { istHausrat } from '../../helper';
import { EnumProduktauswahl } from '../../components/enum';

const Vorschaltseite = () => {
  const produktauswahl = useSelector((state) => state.daten.produktauswahl);
  const gesperrt = useSelector((state) => state.daten.gesperrt);
  const gespeichertAm = useSelector((state) => state.daten.gespeichertAm);
  const dispatch = useDispatch();
  const gotoPage = useGotoPage();
  const nextPage = useNextPage();

  useEffect(() => {
    /**
     * wenn stationär schon gedruckt, dann direkt zur freigabe sprignen
     */
    if (gesperrt.value) {
      i18n.changeLanguage(istHausrat() ? 'spkStationaer' : 'spkStationaerGlas');
      gotoPage('Unterschrift');
    } else if (gespeichertAm.value) {
      i18n.changeLanguage(istHausrat() ? 'spkStationaer' : 'spkStationaerGlas');
      nextPage();
    }
  }, []);

  /**
   * setze sprachdatei und produktauswahl
   * @param {Event} e
   */
  const handleButton = (e) => {
    dispatch(actions.updateByName('daten.produktauswahl.value', e.currentTarget.dataset.value, () => {
      i18n.changeLanguage(istHausrat() ? 'spkStationaer' : 'spkStationaerGlas');
    }));

    dispatch(appActions.serverValidationRequest('validiere', ['produktauswahl'], () => {
      nextPage();
    }));
  };

  return (
    <Row>
      <Col>
        <div className="w-md">
          <BedingungsvergleichButton />
          <Headline>In wenigen Schritten zu Ihrer Hausrat- und Glasversicherung</Headline>
          <Vorgangsanlage>
            <VorgangsanlageButton
              selected={istEnumAuswahl(produktauswahl, EnumProduktauswahl.HAUSRAT)}
              onClick={handleButton}
              dataValue="0"
              label="Hausrat- und Glasversicherung"
              subtitle="Perfekter Schutz für Ihren Wohnungsinhalt."
              icon={<Hausrat />}
            />
            <VorgangsanlageButton
              selected={istEnumAuswahl(produktauswahl, EnumProduktauswahl.GLAS)}
              onClick={handleButton}
              dataValue="1"
              label="Glasversicherung"
              subtitle="Wir zahlen, wenn&apos;s klirrt - und zwar unabhängig von der Ursache."
              icon={<Glas />}
            />
          </Vorgangsanlage>
        </div>
      </Col>
    </Row>
  );
};

export default Vorschaltseite;
